import { BaseSchemes, NodeEditor } from 'rete';
import { AreaPlugin } from 'rete-area-plugin';
import { Position } from 'rete-area-plugin/_types/types';

import { Strategy } from './strategy';

/**
 * Stratégie en cas de déplacer/déposer.
 */
export class DropStrategy<K> implements Strategy {
    /**
     * Fonction utilisée pour créé un noeud.
     */
    createDelegate?: () => BaseSchemes['Node'];

    /**
     * Constructeur.
     * @param editor : Editeur
     * @param area : Zone d'affichage.
     */
    constructor(
        private editor: NodeEditor<BaseSchemes>,
        private area: AreaPlugin<BaseSchemes, K>
    ) {
        area.container.addEventListener('dragover', (e) => {
            e.preventDefault();
        });
        area.container.addEventListener('drop', (event) => {
            if (!this.createDelegate) return;

            try {
                this.area.area.setPointerFrom(event);
                void this.drop(this.createDelegate(), this.area.area.pointer);
            } finally {
                delete this.createDelegate;
            }
        });
    }

    /**
     * Ajoute la capacité de créer des noeuds dans le designer à un élément Html.
     * @param element : Element Html qui pourra être glisser/deposer pour créer un noeud.
     * @param create : Fonction appellée pour créer le noeud
     */
    addNodeCreationCapabilityToElement(element: HTMLElement, create: () => BaseSchemes['Node']) {
        element.draggable = true;

        element.addEventListener('dragstart', () => {
            this.createDelegate = create;
        });
    }

    /**
     * Appellée lorsque l'utilisateur dépose l'éleemnt Html dans le designer.
     * @param node : Instance du noeud à ajouter au designer.
     * @param position : Position où placer le noeud.
     */
    private async drop(node: BaseSchemes['Node'], position: Position) {
        if (node) {
            await this.editor.addNode(node);

            const view = this.area.nodeViews.get(node.id);

            if (!view) throw new Error('view');

            await view.translate(position.x, position.y);
        }
    }
}
